class InfiniteScroll {
  constructor() {
    this.container = document.querySelector('#product-grid');
    this.nextPageUrl = this.getNextPageUrl();
    this.loading = false;
    this.isMobile = window.innerWidth < 750;
    
    if (this.nextPageUrl && this.container) {
      console.log('✅ Infinite Scroll Start - Mobile:', this.isMobile);
      console.log('📄 Nächste Seite:', this.nextPageUrl);
      this.init();
    } else {
      console.log('❌ Fehler - Container:', !!this.container, 'Next URL:', !!this.nextPageUrl);
    }
  }
  
  init() {
    // Pagination ausblenden
    const pagination = document.querySelector('.pagination');
    if (pagination) {
      pagination.style.display = 'none';
      console.log('🔒 Pagination ausgeblendet');
    }
    
    // iOS-optimierter Scroll-Check
    let ticking = false;
    const checkScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          if (this.shouldLoadMore() && !this.loading) {
            console.log('📥 Lade mehr Produkte...');
            this.loadMore();
          }
          ticking = false;
        });
        ticking = true;
      }
    };
    
    // Multiple Event-Listener für iOS
    window.addEventListener('scroll', checkScroll, { passive: true });
    document.addEventListener('scroll', checkScroll, { passive: true });
    window.addEventListener('touchend', () => {
      setTimeout(checkScroll, 100);
    }, { passive: true });
    
    // Initial check nach kurzer Verzögerung
    setTimeout(checkScroll, 500);
    
    console.log('👂 Event Listener registriert');
  }
  
  shouldLoadMore() {
    // iOS-kompatible Scroll-Position
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const documentHeight = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight
    );
    
    const scrollPosition = scrollTop + windowHeight;
    const threshold = this.isMobile ? documentHeight - 2500 : documentHeight - 1000;
    
    const shouldLoad = scrollPosition >= threshold;
    
    if (shouldLoad) {
      console.log('🎯 Scroll-Schwelle erreicht:', {
        scrollPosition: Math.round(scrollPosition),
        threshold: Math.round(threshold),
        documentHeight: Math.round(documentHeight)
      });
    }
    
    return shouldLoad;
  }
  
  getNextPageUrl() {
    const nextLink = document.querySelector('.pagination__item--prev');
    return nextLink ? nextLink.href : null;
  }
  
  async loadMore() {
    if (!this.nextPageUrl) {
      console.log('⛔ Keine weitere Seite');
      return;
    }
    
    this.loading = true;
    this.showLoader();
    console.log('⏳ Lade:', this.nextPageUrl);
    
    try {
      const response = await fetch(this.nextPageUrl);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const newProducts = doc.querySelectorAll('#product-grid > li');
      console.log('📦 Gefundene Produkte:', newProducts.length);
      
      if (newProducts.length === 0) {
        console.warn('⚠️ Keine Produkte gefunden im HTML');
      }
      
      newProducts.forEach((product, index) => {
        const clone = product.cloneNode(true);
        // Animation-Order zurücksetzen für smooth loading
        clone.style.setProperty('--animation-order', index);
        this.container.appendChild(clone);
      });
      
      const nextLink = doc.querySelector('.pagination__item--prev');
      this.nextPageUrl = nextLink ? nextLink.href : null;
      
      console.log('✅ Produkte geladen. Nächste URL:', this.nextPageUrl || 'keine');
      
      if (this.nextPageUrl) {
        const url = new URL(this.nextPageUrl);
        history.replaceState({}, '', url.pathname + url.search);
      }
      
    } catch (error) {
      console.error('❌ Fehler beim Laden:', error);
    } finally {
      this.loading = false;
      this.hideLoader();
    }
  }
  
  showLoader() {
    if (document.querySelector('.infinite-scroll-loader')) return;
    
    const loader = document.createElement('div');
    loader.className = 'infinite-scroll-loader';
    loader.innerHTML = `
      <div class="loading-overlay__spinner">
        <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
    `;
    this.container.after(loader);
    console.log('⏳ Loader angezeigt');
  }
  
  hideLoader() {
    const loader = document.querySelector('.infinite-scroll-loader');
    if (loader) {
      loader.remove();
      console.log('✓ Loader entfernt');
    }
  }
}

// Start mit Verzögerung für iOS
if (document.querySelector('#product-grid')) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => new InfiniteScroll(), 300);
    });
  } else {
    setTimeout(() => new InfiniteScroll(), 300);
  }
}
